// useState guarda valores que pueden cambiar
// cuando cambian, React actualiza la pantalla automáticamente
import { useState } from 'react'

function FormularioSuscripcion({ onSuscripcionCreada, userId }) {
  // Cada campo del formulario tiene su propio estado
  const [nombre, setNombre] = useState('')
  const [costeMensual, setCosteMensual] = useState('')
  const [instruccion, setInstruccion] = useState('')
  const [moneda, setMoneda] = useState('EUR')
  const [enviando, setEnviando] = useState(false)
  const [error, setError] = useState('')

  async function handleSubmit(e) {
    // preventDefault evita que la página se recargue al hacer submit
    e.preventDefault()
    setEnviando(true)
    setError('')

    try {
      // Llamamos a nuestra API de Node que creamos la semana pasada
      const respuesta = await fetch('https://legado-digital-production.up.railway.app/api/subscriptions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          // userId fijo por ahora — en semana 4 usaremos el usuario real
          userId: userId,
          nombre,
          costeMensual: parseFloat(costeMensual) || 0,
          moneda: moneda,
          instruccionHeredero: instruccion,
        }),
      })

      const datos = await respuesta.json()

      if (!datos.ok) {
        setError(datos.error || 'Error al crear la suscripción')
        return
      }

      // Limpiamos el formulario
      setNombre('')
      setCosteMensual('')
      setInstruccion('')

      // Avisamos al componente padre que se creó una nueva
      // para que actualice la lista
      onSuscripcionCreada(datos.datos)

    } catch (err) {
      setError('No se pudo conectar con el servidor')
    } finally {
      setEnviando(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={estilos.formulario}>

      <h3 style={estilos.titulo}>Añadir suscripción</h3>

      {error && (
        <div style={estilos.error}>{error}</div>
      )}

      <div style={estilos.campo}>
        <label style={estilos.label}>Nombre del servicio</label>
        <input
          type="text"
          placeholder="Ej: Netflix, Spotify..."
          value={nombre}
          onChange={e => setNombre(e.target.value)}
          style={estilos.input}
          required
        />
      </div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Coste mensual</label>
        <input
          type="number"
          placeholder="Ej: 9.99"
          value={costeMensual}
          onChange={e => setCosteMensual(e.target.value)}
          style={estilos.input}
          step="0.01"
          min="0"
          required
        />
      </div>

<div style={estilos.campo}>
  <label style={estilos.label}>Moneda</label>
  <select
    value={moneda}
    onChange={e => setMoneda(e.target.value)}
    style={estilos.input}
  >
    <option value="EUR">EUR — Euro</option>
    <option value="USD">USD — Dólar estadounidense</option>
    <option value="GBP">GBP — Libra esterlina</option>
    <option value="MXN">MXN — Peso mexicano</option>
    <option value="ARS">ARS — Peso argentino</option>
    <option value="COP">COP — Peso colombiano</option>
    <option value="CLP">CLP — Peso chileno</option>
    <option value="PEN">PEN — Sol peruano</option>
    <option value="BRL">BRL — Real brasileño</option>
  </select>
</div>

      <div style={estilos.campo}>
        <label style={estilos.label}>Instrucción para herederos</label>
        <input
          type="text"
          placeholder="Ej: Cancelar inmediatamente"
          value={instruccion}
          onChange={e => setInstruccion(e.target.value)}
          style={estilos.input}
        />
      </div>

      <button
        type="submit"
        disabled={enviando}
        style={{
          ...estilos.boton,
          opacity: enviando ? 0.7 : 1,
        }}
      >
        {enviando ? 'Guardando...' : 'Añadir suscripción'}
      </button>

    </form>
  )
}

const estilos = {
  formulario: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '20px',
    border: '1px solid #e0e0e0',
    marginBottom: '24px',
  },
  titulo: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '16px',
    color: '#1a1a2e',
  },
  campo: {
    marginBottom: '14px',
  },
  label: {
    display: 'block',
    fontSize: '13px',
    fontWeight: '500',
    color: '#555',
    marginBottom: '6px',
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    borderRadius: '6px',
    border: '1px solid #ddd',
    fontSize: '14px',
    outline: 'none',
  },
  boton: {
    width: '100%',
    padding: '11px',
    backgroundColor: '#1a1a2e',
    color: '#ffffff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
  },
  error: {
    backgroundColor: '#f8d7da',
    color: '#721c24',
    padding: '10px 12px',
    borderRadius: '6px',
    fontSize: '13px',
    marginBottom: '14px',
  },
}

export default FormularioSuscripcion